<script>
import { mapActions } from 'vuex/dist/vuex.common.js';

export default {
  name: 'PrintBatchesModal',
  props: {
    show: Boolean,
    data: Object,
  },
  emits: [
    'update:show',
  ],
  data: () => ({
    fetching: false,
    batchSize: 1,
    batchQuantity: '',
    isBufferClearingEnabled: true,
  }),
  computed: {
    innerShow: {
      get() {
        return this.show;
      },
      set(v) {
        this.$emit('update:show', v);
      },
    },
    orderId() {
      return this.data?.activeOrder?.order?.id;
    },
    labellingPointIds() {
      return [this.data?.labelingPoint?.id];
    },
    amountLowerUnitInEndUnit() {
      return this.data?.amountLowerUnitInEndUnit || '';
    },
  },
  watch: {
    innerShow(v) {
      if (v) {
        this.batchSize = 1;
        this.batchQuantity = '';
        this.isBufferClearingEnabled = true;
      }
    },
    isBufferClearingEnabled(v) {
      if (v) {
        this.batchSize = 1;
      }
    },
    amountLowerUnitInEndUnit: {
      handler(v) {
        if (v > 0) this.batchQuantity = this.amountLowerUnitInEndUnit;
      },
      deep: true,
      immediate: true,
    },
    batchQuantity(v) {
      if (v < 0) {
        this.batchQuantity = 0;
      }
    },
    batchSize(v) {
      if (v < 0) {
        this.batchSize = 0;
      }
    },
  },
  methods: {
    ...mapActions([
      'printOrderBatches',
    ]),
    async printBatches() {
      try {
        this.fetching = true;

        const batchQuantity = Number(this.amountLowerUnitInEndUnit) === Number(this.batchQuantity)
          ? undefined
          : this.batchQuantity;

        await this.printOrderBatches({
          params: {
            id: this.orderId,
            query: {
              labellingPointIds: this.labellingPointIds,
              isBufferClearingEnabled: this.isBufferClearingEnabled,
              batchSize: this.batchSize,
              batchQuantity,
            },
          },
        });

        this.$bvToast.toast('Operacja powiodła się', {
          title: 'WYSŁANO',
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-bottom-left',
        });
      } catch {
        this.$bvToast.toast('Operacja nie powiodła się', {
          title: 'BŁĄD',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-bottom-left',
        });
      } finally {
        setTimeout(() => {
          this.innerShow = false;
          this.fetching = false;
        }, 10);
      }
    },
  },
};
</script>

<template>
  <BModal
    v-model="innerShow"
    hide-footer
    title="Drukuj manualnie"
  >
    <BOverlay :show="fetching">
      <div>
        <div class="mb-3">
          <div class="d-flex align-items-center mb-1">
            <label for="itemsAmount">
              Ilość kolejnych etykiet do wysłania:
            </label>
          </div>

          <input
            id="itemsAmount"
            v-model="batchSize"
            type="number"
            :disabled="isBufferClearingEnabled"
            class="form-control"
          >

          <div
            v-if="!isBufferClearingEnabled"
            class="button-group d-flex justify-content-center mt-4"
            style="gap: 10px;"
          >
            <BButton
              variant="primary"
              class="btn-sm"
              style="width: 70px;"
              @click="batchSize = +batchSize + 1"
            >
              +1
            </BButton>
            <BButton
              variant="primary"
              class="btn-sm"
              style="width: 70px;"
              @click="batchSize = +batchSize + 5"
            >
              +5
            </BButton>
            <BButton
              variant="primary"
              class="btn-sm"
              style="width: 70px;"
              @click="batchSize = +batchSize + 10"
            >
              +10
            </BButton>
            <BButton
              variant="danger"
              class="btn-sm"
              style="width: 70px;"
              @click="batchSize = +batchSize - 10"
            >
              -10
            </BButton>
            <BButton
              variant="danger"
              class="btn-sm"
              style="width: 70px;"
              @click="batchSize = +batchSize - 5"
            >
              -5
            </BButton>
            <BButton
              variant="danger"
              class="btn-sm"
              style="width: 70px;"
              @click="batchSize = +batchSize - 1"
            >
              -1
            </BButton>
          </div>
        </div>

        <hr
          v-if="amountLowerUnitInEndUnit"
          class="my-4"
        >

        <!-- START: JUST FOR OLIMP LOCK IN FUTURE -->
        <div
          v-if="amountLowerUnitInEndUnit"
          class="mb-3"
        >
          <div class="d-flex align-items-center mb-1">
            <label for="itemsAmount">
              Ilość sztuk na etykiecie:
            </label>
          </div>

          <input
            id="itemsAmount"
            v-model="batchQuantity"
            type="number"
            :placeholder="amountLowerUnitInEndUnit"
            class="form-control"
          >

          <div
            v-if="amountLowerUnitInEndUnit"
            class="button-group d-flex justify-content-center mt-4"
            style="gap: 10px;"
          >
            <BButton
              variant="primary"
              class="btn-sm"
              style="width: 70px;"
              @click="batchQuantity = +batchQuantity + 1"
            >
              +1
            </BButton>
            <BButton
              variant="primary"
              class="btn-sm"
              style="width: 70px;"
              @click="batchQuantity = +batchQuantity + 5"
            >
              +5
            </BButton>
            <BButton
              variant="primary"
              class="btn-sm"
              style="width: 70px;"
              @click="batchQuantity = +batchQuantity + 10"
            >
              +10
            </BButton>
            <BButton
              variant="danger"
              class="btn-sm"
              style="width: 70px;"
              @click="batchQuantity = +batchQuantity - 10"
            >
              -10
            </BButton>
            <BButton
              variant="danger"
              class="btn-sm"
              style="width: 70px;"
              @click="batchQuantity = +batchQuantity - 5"
            >
              -5
            </BButton>
            <BButton
              variant="danger"
              class="btn-sm"
              style="width: 70px;"
              @click="batchQuantity = +batchQuantity - 1"
            >
              -1
            </BButton>
          </div>
        </div>
        <!-- END: JUST FOR OLIMP LOCK IN FUTURE -->

        <hr class="my-4">

        <div class="custom-control custom-switch">
          <input
            id="customSwitch1"
            v-model="isBufferClearingEnabled"
            type="checkbox"
            class="custom-control-input"
          >
          <label
            class="custom-control-label"
            for="customSwitch1"
          >
            Wyczyść aktualny bufor
          </label>
        </div>
      </div>

      <hr class="my-4">

      <div
        class="d-flex justify-content-end mt-4"
        style="gap: 10px;"
      >
        <BButton
          variant="secondary"
          @click="innerShow = false"
        >
          Anuluj
        </BButton>
        <BButton
          variant="primary"
          @click="printBatches"
        >
          Wyślij na drukarkę
        </BButton>
      </div>
    </BOverlay>
  </BModal>
</template>
